// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Replace from "../Control.Monad.Replace/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Unsafe_Reference from "../Unsafe.Reference/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableArray)(Effect.applicativeEffect);
var max = /* #__PURE__ */ Data_Ord.max(Data_Ord.ordInt);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var newEvent = /* #__PURE__ */ Specular_FRP_Base.newEvent(Effect_Class.monadEffectEffect);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var $$void = /* #__PURE__ */ Data_Functor["void"](Effect.functorEffect);
var composeKleisli = /* #__PURE__ */ Control_Bind.composeKleisli(Effect.bindEffect);
var updateList = function (dictMonadFRP) {
    var bind1 = Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1());
    var holdUniqDynBy = Specular_FRP_Base.holdUniqDynBy(dictMonadFRP);
    return function (latestRef) {
        return function (mainSlot) {
            return function (handler) {
                return function (newArray) {
                    return function __do() {
                        var latest = Effect_Ref.read(latestRef)();
                        var newEntries = map(Data_Array.concat)(Data_Function.flip(traverse)(Data_Array.range(0)(max(Data_Array.length(newArray))(Data_Array.length(latest))))(function (i) {
                            var v = Data_Array.index(newArray)(i);
                            var v1 = Data_Array.index(latest)(i);
                            if (v1 instanceof Data_Maybe.Just && v instanceof Data_Maybe.Just) {
                                return function __do() {
                                    $foreign.nextMicrotask(v1.value0.fire(v.value0))();
                                    return [  ];
                                };
                            };
                            if (v1 instanceof Data_Maybe.Just && v instanceof Data_Maybe.Nothing) {
                                return function __do() {
                                    Control_Monad_Replace.destroySlot(v1.value0.slot)();
                                    return [  ];
                                };
                            };
                            if (v1 instanceof Data_Maybe.Nothing && v instanceof Data_Maybe.Just) {
                                return function __do() {
                                    var slot = Control_Monad_Replace.appendSlot(mainSlot)();
                                    var v2 = newEvent();
                                    var result = Control_Monad_Replace.replaceSlot(slot)(bind1(holdUniqDynBy(Unsafe_Reference.unsafeRefEq)(v.value0)(v2.event))(function (dyn) {
                                        return handler(i)(dyn);
                                    }))();
                                    return [ {
                                        slot: slot,
                                        fire: v2.fire,
                                        result: result
                                    } ];
                                };
                            };
                            if (v1 instanceof Data_Maybe.Nothing && v instanceof Data_Maybe.Nothing) {
                                return pure([  ]);
                            };
                            throw new Error("Failed pattern match at Specular.FRP.List (line 66, column 5 - line 81, column 16): " + [ v1.constructor.name, v.constructor.name ]);
                        }))();
                        var newLatest = Data_Array.take(Data_Array.length(newArray))(append(latest)(newEntries));
                        Effect_Ref.write(newLatest)(latestRef)();
                        return map1(function (v) {
                            return v.result;
                        })(newLatest);
                    };
                };
            };
        };
    };
};
var dynamicListWithIndex_ = function (dictMonadFRP) {
    var bind1 = Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1());
    var liftEffect = Effect_Class.liftEffect(dictMonadFRP.MonadEffect0());
    var subscribeDyn_ = Specular_FRP_Base.subscribeDyn_(dictMonadFRP);
    var updateList1 = updateList(dictMonadFRP);
    return function (dictMonadReplace) {
        var newSlot = Control_Monad_Replace.newSlot(dictMonadReplace);
        return function (dynArray) {
            return function (handler) {
                return bind1(liftEffect(Effect_Ref["new"]([  ])))(function (v) {
                    return bind1(newSlot)(function (mainSlot) {
                        return subscribeDyn_((function () {
                            var $74 = updateList1(v)(mainSlot)(handler);
                            return function ($75) {
                                return $$void($74($75));
                            };
                        })())(dynArray);
                    });
                });
            };
        };
    };
};
var dynamicList_ = function (dictMonadFRP) {
    var dynamicListWithIndex_1 = dynamicListWithIndex_(dictMonadFRP);
    return function (dictMonadReplace) {
        var dynamicListWithIndex_2 = dynamicListWithIndex_1(dictMonadReplace);
        return function (dynArray) {
            return function (handler) {
                return dynamicListWithIndex_2(dynArray)(function (v) {
                    return handler;
                });
            };
        };
    };
};
var dynamicListWithIndex = function (dictMonadFRP) {
    var Monad0 = (dictMonadFRP.MonadCleanup1()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind1 = Control_Bind.bind(Bind1);
    var MonadEffect0 = dictMonadFRP.MonadEffect0();
    var liftEffect = Effect_Class.liftEffect(MonadEffect0);
    var newEvent1 = Specular_FRP_Base.newEvent(MonadEffect0);
    var holdDyn = Specular_FRP_Base.holdDyn(dictMonadFRP);
    var discard2 = discard(Bind1);
    var subscribeDyn_ = Specular_FRP_Base.subscribeDyn_(dictMonadFRP);
    var updateList1 = updateList(dictMonadFRP);
    var pure1 = Control_Applicative.pure(Monad0.Applicative0());
    return function (dictMonadReplace) {
        var newSlot = Control_Monad_Replace.newSlot(dictMonadReplace);
        return function (dynArray) {
            return function (handler) {
                return bind1(liftEffect(Effect_Ref["new"]([  ])))(function (v) {
                    return bind1(newSlot)(function (mainSlot) {
                        return bind1(newEvent1)(function (resultChanged) {
                            return bind1(holdDyn([  ])(resultChanged.event))(function (result) {
                                return discard2(subscribeDyn_(composeKleisli(updateList1(v)(mainSlot)(handler))(resultChanged.fire))(dynArray))(function () {
                                    return pure1(result);
                                });
                            });
                        });
                    });
                });
            };
        };
    };
};
var dynamicList = function (dictMonadFRP) {
    var dynamicListWithIndex1 = dynamicListWithIndex(dictMonadFRP);
    return function (dictMonadReplace) {
        var dynamicListWithIndex2 = dynamicListWithIndex1(dictMonadReplace);
        return function (dynArray) {
            return function (handler) {
                return dynamicListWithIndex2(dynArray)(function (v) {
                    return handler;
                });
            };
        };
    };
};
export {
    dynamicListWithIndex,
    dynamicList,
    dynamicListWithIndex_,
    dynamicList_
};
